import {Box, Card, Typography} from "@mui/material";
import React, {useState} from "react";
import AlertsTable from "./AlertsTable/AlertsTable";
import InputText from "../../../Inputs/InputText/InputText";
import Dropdown from "../../../Inputs/Dropdown/Dropdown";
const alertsTableSort = [
  {
    name: 'Alert Id',
    value: 'ET_key'
  },
  {
    name: 'Alert Type',
    value: 'ET_Desc'
  },
  {
    name: 'Quantity',
    value: 'ES_Quantity'
  },
  {
    name: 'Description',
    value: 'LogLoc_Desc'
  },
  {
    name: 'Received On',
    value: 'receivedOn'
  },
];

const AlertsTableContainer = () => {
  const [isDebounceRunning, setIsDebounceRunning] = useState(false);
  const [tableSearch, setTableSearch] = useState('');
  const [tableSort, setTableSort] = useState('');
  const headingStyles = { fontSize: "22px", lineHeight: '22px', fontWeight: "600", color: "#1B3665" };

  return (
   <Card sx={{ padding: "20px", maxHeight: "403px", height: "403px", boxShadow: "0px 4px 40px 0px rgba(226, 236, 249, 0.60)", borderRadius: "12px" }}>
    <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: "space-between", marginBottom: "10px", gap: "10px" }}>
     <Typography sx={headingStyles}>Alerts</Typography>
     <Box sx={{ display: 'flex', gap: "15px", marginBottom: "25px" }}>
      <InputText
        withDebounce={true}
        value={tableSearch}
        debounceDelay={1000}
        onChangeFn={(value) => setTableSearch(value)}
        onDebounceEnd={() => setIsDebounceRunning(false)}
        onDebounceStart={() => setIsDebounceRunning(true)}
      />
      <Dropdown
        withDebounce={true}
        value={tableSort}
        options={alertsTableSort}
        debounceDelay={1000}
        onChangeFn={(value) => setTableSort(value)}
        onDebounceEnd={() => setIsDebounceRunning(false)}
        onDebounceStart={() => setIsDebounceRunning(true)}
      />
     </Box>
    </Box>
     <AlertsTable search={tableSearch} sort={tableSort} isDebounceRunning={isDebounceRunning} />
   </Card>
  );
}

export default AlertsTableContainer;
